import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { Toaster } from "react-hot-toast";
import { Button } from "react-bootstrap";
import { formatDateTime, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import Adjust from "./Adjust";

const Tables = () => {
  const { getData, Per_Page_Dropdown, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [option, setOption] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [searchDate, setSearchDate] = useState("");
  const [searchDateTo, setSearchDateTo] = useState("");
  const [loader, setLoader] = useState(false);
  const [mode, setMode] = useState(null); // "add" | "reduce" | null

  const getDataAll = async () => {
    setLoader(true);
    const response = await getData(
      `/admin/purchase-order/stock-adjustment?page=${onPageChange}&per_page=${perPage}&term=${
        search || ""
      }&from=${searchDate || ""}&to=${searchDateTo || ""}`,
    );
    setData(response);
    if (response?.success) setLoader(false);
    setCurrentPage(response?.data?.current_page);
    setperPage(response?.data?.per_page);
    setSearch(response?.data?.search_name);
    settotalPages(response?.data?.total_pages);
    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
  }, [perPage, reset, mode, onPageChange]);

  const handlePageChange = (pageNumber) => setonPageChange(pageNumber);

  const canAdd = isAllow?.includes(IDS.Receiving_Order.Add);

  return (
    <>
      <div className="main-advancedashboard">
        <Header
          title={"Stock Adjustment"}
          link={"/admin/masters/purchase-order/stock-adjustment"}
        />
        <div className="row me-0 ms-0">
          <div className="row MainRowsec me-0 ms-0">
            <section className="AdvanceDashboard">
              <div className="col-xxl-12 col-xl-12 p-0 ">
                <section className="Tabels tab-radio mt-3">
                  <div className="row p-2">
                    {canAdd && (
                      <>
                        <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                          <div className="add me-3">
                            <Link type="button" className="btn btn-add pe-3">
                              <div onClick={() => setMode("add")}>
                                <p className="add-sub-txttt">
                                  <img
                                    src={plus}
                                    className="plus me-2 ms-0"
                                    alt=""
                                  />
                                  Add Stock
                                </p>
                              </div>
                            </Link>
                          </div>
                        </div>
                        <div className="col-xxl-2 col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                          <div className="add me-3">
                            <Link type="button" className="btn btn-add pe-3">
                              <div onClick={() => setMode("reduce")}>
                                <p className="add-sub-txttt">Reduce Stock</p>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-4">
                    <div className="col-12">
                      <div className="top-showing-wrapper sowing ms-3 me-2">
                        <p className="show m-0">Show</p>
                        <select
                          className="form-select form-select-sm"
                          onChange={(e) => {
                            setonPageChange(1);
                            setperPage(e.target.value);
                          }}
                        >
                          {option?.map((o) => (
                            <option key={o} value={o}>
                              {o}
                            </option>
                          ))}
                        </select>
                        <p className="show m-0">
                          Entries{" "}
                          {`Showing ${Math.min(
                            (currentPage - 1) * perPage + 1,
                          )} to ${Math.min(
                            currentPage * perPage,
                            data?.data?.total,
                          )} of ${data?.data?.total} entries`}
                        </p>
                      </div>
                    </div>

                    <div className="col-12">
                      <div className="row align-items-end">
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 mb-2">
                          <label className="form-label">Reason</label>
                          <input
                            type="text"
                            className="form-control"
                            value={search}
                            placeholder="Search Reason"
                            onChange={(e) => {
                              setonPageChange(1);
                              setSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 mb-2">
                          <label className="form-label">Start Date</label>
                          <input
                            type="date"
                            className="form-control"
                            max="9999-12-31"
                            value={searchDate}
                            onChange={(e) => {
                              setSearchDate(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                        </div>
                        <div className="col-xxl-2 col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 mb-2">
                          <label className="form-label">End Date</label>
                          <input
                            type="date"
                            className="form-control"
                            max="9999-12-31"
                            value={searchDateTo}
                            onChange={(e) => {
                              setSearchDateTo(e.target.value);
                              setonPageChange(1);
                            }}
                          />
                        </div>
                        <div className="col-xxl-1 col-xl-1 col-lg-1 col-md-1 col-sm-2 col-3 mb-2">
                          <div className="Search me-2">
                            <Button
                              type="button"
                              onClick={() => {
                                setonPageChange(1);
                                getDataAll();
                              }}
                              className="btn btn-search"
                            >
                              <img src={search1} className="search" alt="" />
                            </Button>
                          </div>
                        </div>
                        <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-3 mb-2">
                          <div className="Search-1">
                            <button
                              type="button"
                              onClick={() => {
                                setSearch("");
                                setSearchDate("");
                                setSearchDateTo("");
                                setReset(!reset);
                              }}
                              className="btn btn-reset"
                            >
                              Reset
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="alert alert-warning ms-2 mt-2 py-2 fw-semibold">
                    Manual stock additions are listed under{" "}
                    <Link to="/purchase-product/receiving-order">
                      Receiving Order
                    </Link>
                    .
                  </div>
                  <div className="border-line mt-3"></div>

                  <div className="row mt-3 p-1">
                    <h6 className="ms-2">Stock Reduction History</h6>

                    <div className="data table-responsive">
                      <Table striped bordered hover responsive>
                        <thead>
                          <tr>
                            <th className="sr">Sr. No.</th>
                            <th className="tax-name">Product</th>
                            <th className="tax-name">Variant</th>
                            <th className="tax-name">Quantity Reduced</th>
                            <th className="tax-name">Stock Before</th>
                            <th className="tax-name">Stock After</th>
                            <th className="tax-name">Reason</th>
                            <th className="tax-name">Remark</th>
                            <th className="tax-name">By</th>
                            <th className="tax-name">Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loader ? (
                            <tr>
                              <td colSpan="10" className="text-center py-4">
                                <div
                                  className="spinner-border text-primary"
                                  role="status"
                                >
                                  <span className="visually-hidden">
                                    Loading...
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ) : (
                            data?.data?.data?.map((row, index) => (
                              <tr key={row.id}>
                                <td>
                                  {(currentPage - 1) * perPage + index + 1}
                                </td>
                                <td>{row?.Product?.name || "-"}</td>
                                <td>
                                  {row?.Product_Variant?.Metal?.name || "-"}
                                </td>
                                <td className="text-danger">-{row.quantity}</td>
                                <td>{row.stock_before}</td>
                                <td>{row.stock_after}</td>
                                <td>{row.reason || "-"}</td>
                                <td>{row.remark || "-"}</td>
                                <td>{row?.User?.name || "-"}</td>
                                <td>{formatDateTime(row.createdAt)}</td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </Table>
                      {data && data?.data?.data?.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={handlePageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </section>
              </div>
            </section>
          </div>
        </div>
      </div>

      {mode && (
        <Adjust mode={mode} show={!!mode} handleClose={() => setMode(null)} />
      )}
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
